<template>
	<value-container v-if="view_only" :value="text" :label="label" :md="md" :offset="offset"/>
	<component v-else :is='c_tag' :md3="md==3" :md4="md==4" :md5="md==5" :md6="md==6" :md8="md==8" :md12="md==12" :offset-md4="offset==4" :offset-md8="offset==8" >
		<fs1-span><b>{{label || ''}}</b></fs1-span>
		<slot></slot>
		<v-text-field
			:class="text != null ? '': (optional?'':'textEmpty')"
			:placeholder="c_placeholder"
			:value="text"
			:disabled="disabled"
			:hide-details="!!condensed"
			:prepend-icon="p_icon"
			v-on:input="updateInput"/>
			<value-container v-if="old_value !== undefined" :value="old_value||''" class_name="output_old_value_edit"/>
	</component>
</template>

<script>
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  model: { prop: "text", event: "input" },
	props: ['text'],
  methods: { updateInput(v) { this.$emit('input', v) } }
};
</script>
